import {IContentMapper} from "../base.content";
import {GalleryContentDTO, GalleryContent, GalleryContentItem, GalleryContentItemParams} from "../gallery.content";
import {cmsTypeToString} from "../../constants";

export class GalleryMapper implements IContentMapper {
  toDTO(data: GalleryContent): GalleryContentDTO {
    return {
      type: cmsTypeToString(data.type),
      label: data.label,
      items: data.items.toArray().map((item) => ({
        original: item.url,
        thumbnail: item.thumbnail
      }))
    };
  }

  fromDTO(data: GalleryContentDTO): GalleryContent {
    return new GalleryContent({
      label: data.label,
      items: data.items.map((itemData) => new GalleryContentItem(new GalleryContentItemParams({
        original: itemData.original,
        thumbnail: itemData.thumbnail,
      })))
    });
  }

}



// WEBPACK FOOTER //
// ./src/api/club-cms/content/mappers/gallery.ts